/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaymentsCheckoutRequestDto } from '../models/PaymentsCheckoutRequestDto';
import type { PaymentsCheckoutStatusResponseDto } from '../models/PaymentsCheckoutStatusResponseDto';
import type { PaymentsDashboardResponseDto } from '../models/PaymentsDashboardResponseDto';
import type { PaymentsRedirectResponseDto } from '../models/PaymentsRedirectResponseDto';
import type { PaymentsSubscriptionStatusResponseDto } from '../models/PaymentsSubscriptionStatusResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PaymentsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns PaymentsRedirectResponseDto
     * @throws ApiError
     */
    public checkout({
        requestBody,
    }: {
        requestBody: PaymentsCheckoutRequestDto,
    }): CancelablePromise<PaymentsRedirectResponseDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/payments/checkout',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaymentsCheckoutStatusResponseDto
     * @throws ApiError
     */
    public checkoutStatus({
        checkoutSession,
    }: {
        checkoutSession: string,
    }): CancelablePromise<PaymentsCheckoutStatusResponseDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/payments/checkout/status',
            query: {
                'checkout_session': checkoutSession,
            },
        });
    }
    /**
     * @returns PaymentsSubscriptionStatusResponseDto
     * @throws ApiError
     */
    public subscriptionStatus(): CancelablePromise<PaymentsSubscriptionStatusResponseDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/payments/subscription/status',
        });
    }
    /**
     * @returns PaymentsDashboardResponseDto
     * @throws ApiError
     */
    public getDashboardUrl(): CancelablePromise<PaymentsDashboardResponseDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/payments/dashboard',
        });
    }
}
